// @flow
import { useMemo, useCallback } from "react";
import { types as ats } from "../../../actions";

import type { GridProps } from "../types";
import {
	TOTAL_PAGE_SIZE,
	FOLDER_HEIGHT,
	GRID_TYPES,
	getTopSection,
	renderGridItem,
	loadMoreItems,
} from "./shared";

const {
	LOAD_NAVIGATION_FOLDERS,
	LOAD_SEARCH_FOLDERS,
} = ats;

export default (props: GridProps) => {
	const {
		folderId,
		folderPath,
		folderKind,
		folderDriveId,
		folders,
		foldersCursor,
		term,
		foldersIsPending,
		orderBy,
		sort,
		actions,
	} = props;

	const totalFolders = folders.length + (foldersCursor ? TOTAL_PAGE_SIZE : 0);
	const isFolderLoaded = useCallback((index: number) => !!folders[index], [folders]);

	const loadMore = useCallback(() => {
		const action = actions[term ? LOAD_SEARCH_FOLDERS : LOAD_NAVIGATION_FOLDERS];
		return loadMoreItems(action, foldersIsPending, foldersCursor, {
			term,
			sort,
			orderBy,
			folderId,
			folderPath,
			folderKind,
			folderDriveId,
		});
	},
	[actions, term, folderId, folderPath, folderKind, folderDriveId, sort, orderBy, foldersIsPending, foldersCursor]);

	const foldersSection = useMemo(
		() => ({
			top: getTopSection(GRID_TYPES.FOLDERS, folders, totalFolders),
			itemHeight: FOLDER_HEIGHT,
			totalItems: totalFolders,
			renderItemComponent: renderGridItem,
			isItemLoaded: isFolderLoaded,
			loadMore,
			itemProps: {
				type: GRID_TYPES.FOLDERS,
				items: folders,
				total: totalFolders,
			},
		}),
		[
			totalFolders,
			folders,
			isFolderLoaded,
			loadMore,
		],
	);

	return foldersSection;
};
